// 地块绘制模块
const L = window.L;
const turf = window.turf;
import {
  SHEPSG4326CRS,
  createShanghaiMapLayers,
} from "@/mixins/map/shTileLayer";
import getGisToken from "@/mixins/map/getGisToken.js";
import { getStorage } from "@/utils/storage";
import areaTileLayer from "@/mixins/map/areaTileLayer";

export const mapTools = {
  //地图层级 配置
  configMapLayer(type) {
    //边界线>谷歌带导入卫星图>天地图卫星>高德2D地图
    var boundLine = L.tileLayer.chinaProvider("TianDiTu.Realm.Map", {
        //边境线
        id: "layer_line",
        detectRetina: false,
        zIndex: 5,
        maxZoom: 21,
        minZoom: 5,
        maxNativeZoom: 21,
      }),
      satelliteMap = L.tileLayer.chinaProvider("Google.Satellite.Map", {
        //谷歌卫星图无地名 (与谷歌地名标注资源 二选一)
        id: "layer_google",
        detectRetina: false,
        zIndex: 3, //层级越高 越在上面
        maxZoom: 21,
        minZoom: 5,
        maxNativeZoom: 22,
      }),
      ggAnnotionMap = L.tileLayer.chinaProvider("Google.Satellite.Annotion", {
        //谷歌卫星图 有地名标注  (与谷歌无地名资源 二选一)
        id: "layer_google",
        detectRetina: false,
        zIndex: 3, //层级越高 越在上面
        maxZoom: 21,
        minZoom: 5,
        maxNativeZoom: 22,
      }),
      tianDiSatelliteMap = L.tileLayer.chinaProvider("TianDiTu.Satellite.Map", {
        //天地卫星图
        id: "layer_tiandi",
        detectRetina: false,
        zIndex: 2,
        maxZoom: 18,
        minZoom: 5,
        maxNativeZoom: 18,
      }),
      gaode2d = L.tileLayer.chinaProvider("GaoDe.Normal.Map", {
        //高德 2D 地图
        id: "layer_gaodeLabel",
        detectRetina: false,
        zIndex: 1,
        maxZoom: 18,
        minZoom: 5,
        maxNativeZoom: 19,
      });
    if (type === "showaddress") {
      return [boundLine, ggAnnotionMap, tianDiSatelliteMap, gaode2d];
    }
    return [boundLine, satelliteMap, tianDiSatelliteMap, gaode2d];
  },
  //初始化地图
  async initMap(el, center, showShanghaiMap, setOption) {
    var leafletloaded = await mapTools.leafletLoaded();
    if (!leafletloaded) return;
    //初始化地图
    let optionDefault = {
      name: "base",
      center: center,
      zoom: 14,
      zoomControl: false,
      attributionControl: false,
      dragging: true,
      touchZoom: false,
      scrollWheelZoom: true,
      doubleClickZoom: true,
      boxZoom: false,
      tap: false,
      keyboard: false,
      preferCanvas: false,
    };
    // 谷歌卫星底图 地图
    const satelliteMap = L.tileLayer.chinaProvider("Google.Satellite.Map", {
      className: "layer_google",
      detectRetina: false,
      zIndex: 3,
      maxZoom: 21,
      minZoom: 5,
      maxNativeZoom: 22,
    });
    // 高德 2D 地图
    const gaode2d = L.tileLayer.chinaProvider("GaoDe.Normal.Map", {
      className: "layer_gaodeLabel",
      detectRetina: false,
      zIndex: 1,
      maxZoom: 18,
      minZoom: 5,
    });
    optionDefault.layers = [satelliteMap, gaode2d];
    let shLayers = null;
    if (showShanghaiMap) {
      var gisToken = await getGisToken("shanghai");
      shLayers = createShanghaiMapLayers(gisToken);
      optionDefault = Object.assign(optionDefault, {
        layers: [shLayers.initialLayer],
        crs: SHEPSG4326CRS,
        zoom: 6,
        maxZoom: 9,
        minZoom: 0,
      });
    }
    // 查询当前区域是否配置了 区域卫星影像服务
    let areaServeUrl = this.getAreaServer();
    if (areaServeUrl) {
      let jyLayer = await areaTileLayer();
      optionDefault.layers.unshift(jyLayer);
    }
    optionDefault.layers.map((layerOption) => {
      layerOption.options.type = "base";
    });
    if (setOption && typeof setOption === "function") {
      optionDefault = setOption(optionDefault);
    }
    return new Promise((resolve) => {
      if (!el) return resolve(null);
      const map = L.map(el, optionDefault);
      if (shLayers) {
        shLayers.setFallback(map);
      }
      map.whenReady(function () {
        resolve(map);
      });
      setTimeout(() => {
        resolve(null);
      }, 5000);
    });
  },
  getAreaServer() {
    let gisServerList = getStorage("GISSERVERLIST") || [];
    let gisServer = gisServerList.filter(
      (item) => item && item.serverCategory && item.serverCategory === 22
    );
    if (gisServer && gisServer.length && gisServer[0]["serverUrl"]) {
      return gisServer[0]["serverUrl"];
    }
    return;
  },
  getPolygonAreaFn(path) {
    return new Promise(async (resolve) => {
      var hasturf = await this.turfAreaLoaded();
      if (!hasturf) {
        resolve(0);
        return;
      }
      var polygon = turf.polygon([path]);
      var area = turf.area(polygon);
      resolve(area);
    });
  },
  // 载入turf依赖
  turfAreaLoaded() {
    return new Promise(async (resolve) => {
      await this.loadSource(function () {
        return !(window.turf && window.turf.area);
      }, getLinkScript);
      resolve(true);

      function getLinkScript() {
        var hm = document.createElement("script");
        hm.id = "areaMeasure";
        hm.src =
          "https://snkoudai.oss-cn-hangzhou.aliyuncs.com/common/plugins/turf/turf-area.min.js";
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
      }
    });
  },
  // 载入leaflet依赖
  leafletLoaded() {
    return new Promise(async (resolve) => {
      await this.loadSource(function () {
        return !window.L;
      }, getLinkScript);
      await this.loadSource(function () {
        return !(window.L && window.L.tileLayer.chinaProvider);
      }, getLinkScriptplus);
      resolve(true);

      function getLinkScript() {
        var link = document.createElement("link");
        link.setAttribute("type", "text/css");
        link.setAttribute("rel", "stylesheet");
        link.setAttribute(
          "href",
          "https://snkoudai.oss-cn-hangzhou.aliyuncs.com/common/plugins/map/leaflet.css"
        );
        var hm = document.createElement("script");
        hm.id = "leaflet";
        hm.src =
          "https://snkoudai.oss-cn-hangzhou.aliyuncs.com/common/plugins/map/leaflet.js";
        document.head.appendChild(link);
        document.head.appendChild(hm);
      }

      function getLinkScriptplus() {
        var hmplus = document.createElement("script");
        hmplus.id = "leaflet-source";
        hmplus.src =
          "https://snkoudai.oss-cn-hangzhou.aliyuncs.com/common/plugins/map/leaflet.ChineseTmsProviders.js";
        document.head.appendChild(hmplus);
      }
    });
  },
  // 依赖加载器，condition检测依赖是否载入函数，doing依赖载入函数
  loadSource(condition, doing) {
    var errori = 0,
      timer;
    return new Promise((resolve) => {
      if (condition()) {
        doing();
      } else {
        resolve(true);
        return;
      }
      timer = setInterval(() => {
        errori++;
        if (!condition()) {
          resolve(true);
          clearInterval(timer);
        }
        if (errori > 150) {
          clearInterval(timer);
          resolve(false);
        }
      }, 50);
    });
  },
};
